(function() {
  // Sachet main variant IDs
  const sachetMainIds = new Set([
    '59256152588622', '59256152686926', '59256152785230', '59256152883534',
    '59256152621390', '59256152719694', '59256152817998', '59256152916302',
    '59256152654158', '59256152752462', '59256152850766', '59256152949070'
  ]);

  // No Cup main variant IDs
  const noCupMainIds = new Set([
    '59255395615054', '59255395713358', '59255395811662', '59255395909966',
    '59255395647822', '59255395746126', '59255395844430', '59255395942734',
    '59255395680590', '59255395778894', '59255395877198', '59255395975502'
  ]);

  // Coffee 2.0 subscription main variant IDs
  const coffee20SubscriptionIds = new Set([
    '59427435905358',
    '59427435938126',
    '59427435970894',
    '59427436003662'
  ]);

  // Coffee 2.0 gift variant IDs
  const coffee20GiftIds = new Set([
    '59427621339470',
    '53732857938254',
    '53732855808334'
  ]);

  const NO_CUP_UPSELL_VARIANT_ID = '59255361536334';

  let cleaning = false;
  const originalFetch = window.fetch;

  function refreshCart() {
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    if (typeof window.upcartUpdateCart === 'function') window.upcartUpdateCart();
    document.dispatchEvent(new CustomEvent('upcart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  window.fetch = function (...args) {
    const [url] = args;
    const urlStr = typeof url === 'string' ? url : url?.url || '';
    const isCartChange = /\/cart\/(change|update)\.js/.test(urlStr);

    if (!isCartChange || cleaning) {
      return originalFetch.apply(this, args);
    }

    return originalFetch.apply(this, args).then(response => {
      const cloned = response.clone();
      cloned.json().then(cart => {
        const items = cart.items || [];
        const updates = {};
        let needsCleanup = false;

        // 1. Remove free sachets if no sachet main product in cart
        const hasSachetMain = items.some(i => sachetMainIds.has(String(i.variant_id)));
        if (!hasSachetMain) {
          items.filter(i => i.properties?._sachet_free === 'true').forEach(i => {
            updates[i.key] = 0;
            needsCleanup = true;
          });
        }

        // 2. Remove no cup upsell if no no cup main product in cart
        const hasNoCupMain = items.some(i => noCupMainIds.has(String(i.variant_id)));
        if (!hasNoCupMain) {
          items.filter(i => String(i.variant_id) === NO_CUP_UPSELL_VARIANT_ID).forEach(i => {
            updates[i.key] = 0;
            needsCleanup = true;
          });
        }

        // 3. Coffee 2.0 subscription + gifts quantity sync
        const coffee20SubItem = items.find(i =>
          coffee20SubscriptionIds.has(String(i.variant_id)) && i.selling_plan_allocation
        );
        const hasCoffee20OneTime = items.some(i =>
          coffee20SubscriptionIds.has(String(i.variant_id)) && !i.selling_plan_allocation
        );

        if (!coffee20SubItem) {
          // No subscription in cart — remove all gifts
          items.filter(i => coffee20GiftIds.has(String(i.variant_id))).forEach(i => {
            updates[i.key] = 0;
            needsCleanup = true;
          });
        } else {
          // Subscription exists — sync gift quantities to match subscription quantity
          const subQty = coffee20SubItem.quantity;
          items.filter(i => coffee20GiftIds.has(String(i.variant_id))).forEach(i => {
            if (i.quantity !== subQty) {
              updates[i.key] = subQty;
              needsCleanup = true;
            }
          });
        }

        // Subscription takes priority — remove one-time if subscription also in cart
        if (coffee20SubItem && hasCoffee20OneTime) {
          items.filter(i =>
            coffee20SubscriptionIds.has(String(i.variant_id)) && !i.selling_plan_allocation
          ).forEach(i => {
            updates[i.key] = 0;
            needsCleanup = true;
          });
        }

        if (needsCleanup) {
          cleaning = true;
          originalFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          })
            .then(r => r.json())
            .then(() => {
              cleaning = false;
              refreshCart();
              document.dispatchEvent(new CustomEvent('nocup-upsell:removed'));
            })
            .catch(err => {
              cleaning = false;
              console.error('Cart cleanup error:', err);
            });
        }
      }).catch(() => {});

      return response;
    });
  };
})();